import React, { FC } from "react";
import { Box } from "@UI/Components/Box/Box";
import { Flex } from "@UI/Components/Flex/Flex";
import { Text } from "@UI/Components/Text/Text";
import { CircleInfo } from "@UI/Components/Icons/CircleInfo";
import { List, ListItem } from "@UI/Components/List/List";

export interface HintsBoxProps {
  /** Resolved `hints_intro` — the bold line above the hint list. */
  title?: string;
  /** Resolved hint copy, in config order (see `utils/resolveHints.ts`). */
  hints?: string[];
}

/**
 * Shared hint callout every question type renders above its field, so the
 * styling stays identical instead of being reimplemented per question.
 * Renders nothing when there are no hints, so callers can pass them blindly.
 */
export const HintsBox: FC<HintsBoxProps> = ({ title, hints }) => {
  if (!hints || hints.length === 0) return null;

  return (
    <Flex
      borderWidth="1px"
      borderColor="gray.300"
      borderRadius="lg"
      padding={4}
      mb={4}
      gap={3}
      align="center"
    >
      <CircleInfo />
      <Box>
        {title && (
          <Text fontWeight="semibold" mb={1}>
            {title}
          </Text>
        )}
        <List spacing={1} styleType="disc" pl={4}>
          {hints.map((hint) => (
            <ListItem key={hint}>{hint}</ListItem>
          ))}
        </List>
      </Box>
    </Flex>
  );
};
